import Vue from 'vue';
import Component from 'vue-class-component';

import BbModal from 'common/components/BbModal';
import Rating from 'common/components/Rating';
import BaseProductReview from 'components/BaseProductReview';


@Component({
  props: {
    ratingValue: {
      type: Number,
    },
    surveyQuantity: {
      type: Number,
      required: true,
    },
    productId: {
      type: [String, Number],
      required: true,
    },
    productType: {
      type: String,
    },
    noReviewsMessage: {
      type: String,
      required: true,
    },
  },
  components: {
    BbModal,
    Rating,
    BaseProductReview,
  },
})
export default class ReviewsBarComponent extends Vue {

  modalVisibility = false;

  toggleModalVisibility() {
    this.modalVisibility = !this.modalVisibility;
    document.getElementsByClassName('baseView')[0].style.overflow = this
      .modalVisibility
      ? 'hidden'
      : 'auto';
  }
}
